import { jsx as _jsx } from "react/jsx-runtime";
import { Input, EInputVariant, } from "../../../../Input";
export const TextFilter = (props) => {
    const { sx = {}, dataComponentName, label, helperLabel, value, onChange, } = props;
    return (_jsx(Input, { sx: sx, dataComponentName: [dataComponentName, "TextFilter"].filter(Boolean).join(' '), label: label, variant: EInputVariant.OUTLINED, placeholder: "Type...", helperLabel: helperLabel, value: value, onChange: onChange }));
};
